/** Connected lens: security optics + a network node, in an open technical frame.
 * Shared light/dark lockup; retains the SkyTech palette and Inter (SRS §4.2, §8.3).
 */
export function BrandLogo({ inverse = false }: { inverse?: boolean }): JSX.Element {
  return (
    <span className="inline-flex shrink-0 items-center gap-2.5" aria-hidden="true">
      <svg
        viewBox="0 0 48 48"
        width="44"
        height="44"
        className={`shrink-0 ${inverse ? 'text-white' : 'text-navy-900'}`}
        fill="none"
      >
        <path
          d="m29 6-5-3L6 13v22l18 10 18-10V24"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="24" cy="24" r="9.5" stroke="currentColor" strokeWidth="2.5" />
        <circle cx="24" cy="24" r="3" fill="currentColor" />
        <path
          d="m34 9 8 4v4"
          stroke="var(--color-sky-500)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="42" cy="18" r="2.5" fill="var(--color-sky-500)" />
      </svg>
      <span className="flex flex-col gap-1.5">
        <span
          className={`text-[26px] font-light leading-none tracking-[-0.035em] ${inverse ? 'text-white' : 'text-navy-900'}`}
        >
          Sky<span className="font-normal">Tech</span>
        </span>
        <span
          className={`pl-0.5 text-[10px] font-medium leading-none tracking-[0.24em] ${inverse ? 'text-white/90' : 'text-navy-700'}`}
        >
          SOLUTIONS
        </span>
      </span>
    </span>
  );
}
